import axios from 'axios';
import { API_BASE } from '../lib/apiBase';

const API = API_BASE;

export const guestApi = {
  config: (token) => axios.get(`${API}/guest/${token}/config`, { withCredentials: true }).then((r) => r.data),
  verify: (token, pin) => axios.post(`${API}/guest/${token}/verify`, { pin }, { withCredentials: true }).then((r) => r.data),
  logout: (token) => axios.post(`${API}/guest/${token}/logout`, {}, { withCredentials: true }).then((r) => r.data),
};
